export default "__VITE_ASSET__zoL4c3yW__"